import { MessageEventBus, ModelEventBus, ProgressBarEventBus } from "../../event-bus";
import RappidContext from "../rappid/rappid-context";
import GeneratorModelState from "./generation/generator-model-state";
import { getStatechart } from "./model-helper";
import { editorStateStore } from "./storage/editor-state-store";

export default class ModelLoader {
  constructor(
    private rappidContext: RappidContext,
    private generatorModelState: GeneratorModelState
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadModelFromJson(json: any, id?: string, successMsg?: string) {
    if (json.graph) {
      this.setGraph(json.graph, id);
    } else {
      this.setGraph(json, id);
    }
    ProgressBarEventBus.emit("finishedTask");
    const finalSuccessMsg = successMsg ?? (id ? "New Statechart opened!" : "New Statechart created!");
    MessageEventBus.emit("success", {
      text: finalSuccessMsg,
      id: "open-item",
    });

    if (json.genModel) {
      this.generatorModelState.setGeneratorModel(json.genModel);
    } else {
      this.generatorModelState.resetGeneratorModel();
    }
  }

  saveModelToText(graph = undefined): string {
    const model = {
      graph: graph ?? this.rappidContext.paper.model,
      genModel: this.generatorModelState.getGeneratorModel(),
    };
    return JSON.stringify(model, null, 2);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private setGraph(graphJson: any, id: string) {
    replaceLegacyTypes(graphJson);
    loadStatechartGraphFromJson(this.rappidContext, graphJson);

    setTimeout(() => {
      this.rappidContext.paperScroller.zoom(1 - this.rappidContext.paperScroller.zoom());
      this.rappidContext.paperScroller.centerContent();
    });

    editorStateStore().setModelId(id);
    ModelEventBus.emit("modelLoaded", {
      statechart: getStatechart(this.rappidContext.paper.model),
    });
  }
}
/**
 * Migrate legacy model history types after refactoring of #904
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function replaceLegacyTypes(jsonData: any) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  jsonData.cells.forEach((cell: any) => {
    if (cell.type === "Entry" && cell.entryKind === "Entry") {
      cell.entryKind = "Initial";
    }
    if (cell.type === "DeepHistory") {
      cell.type = "Entry";
      cell.entryKind = "DeepHistory";
    } else if (cell.type === "ShallowHistory") {
      cell.type = "Entry";
      cell.entryKind = "ShallowHistory";
    }
  });
}

/**
 * Load statechart correctly from json, by setting attrs and transitions correctly
 */
export function loadStatechartGraphFromJson(rappidContext: RappidContext, graphJson) {
  rappidContext.graph.fromJSON(graphJson, { mergeArrays: true });
  rappidContext.commandManager.reset();
}
